// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l7Aja","clinicsSelect":"styles_clinicsSelect__2kZKy"};